import convert from 'htmr';
import styled, { css } from 'styled-components';

import { constants } from '@hero/configs';
import { GiftMessageArea } from '@hero/molecules';

const Wrapper = styled.div`
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  margin-bottom: 4px;
  margin-top: 4px;
  min-height: 40px;
  padding: 16px;
  width: 100%;

  ${({ isFocused }) =>
    !isFocused &&
    css`
      outline-color: var(--color-border-default);
      transition: all 0.2s ease-in-out;

      &:hover {
        cursor: pointer;
        outline: 1px solid var(--color-border-default);
      }
    `}
`;

const ReadOnlyText = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  overflow: hidden;
`;

export function ColumnGiftMessageEditor({ isFocused, onChange, readOnly, onFocus, ...props }) {
  return (
    <Wrapper onClick={onFocus} isFocused={isFocused}>
      {isFocused && !readOnly ? (
        <GiftMessageArea
          textAreaProps={{
            isFocused,
            onChange: val => {
              onChange(undefined, val);
            },
            limit: constants?.general?.giftMessageLimit,
            ...props
          }}
        />
      ) : (
        <ReadOnlyText>{convert(props.value || '')}</ReadOnlyText>
      )}
    </Wrapper>
  );
}
